/**
 * Lifecycle badge shared by every Agent Factory surface (Design §19.4 shared chrome).
 */

import React from 'react';
import { useLanguage } from '@/state/language/LanguageProvider';
import type { StudioLifecycleStatus } from '@/types/aiStudioAgent';

const STATUS_CLASSES: Record<StudioLifecycleStatus, string> = {
  draft: 'border-[var(--color-border)] text-[var(--color-surface-text-secondary)]',
  published: 'border-[var(--color-success)] text-[var(--color-success)]',
  superseded: 'border-[var(--color-warning)] text-[var(--color-warning)]',
  deprecated: 'border-[var(--color-warning)] text-[var(--color-warning)]',
  archived: 'border-[var(--color-border)] text-[var(--color-surface-text-secondary)]',
};

interface LifecycleBadgeProps {
  status: StudioLifecycleStatus;
}

export const LifecycleBadge: React.FC<LifecycleBadgeProps> = ({ status }) => {
  const { t } = useLanguage();
  return (
    <span
      className={`inline-block rounded-full border px-2 py-0.5 text-base ${STATUS_CLASSES[status]}`}
    >
      {t(`aiStudio.status.${status}`)}
    </span>
  );
};
